import { z } from 'zod';

import { idSchema, isoDateTimeSchema } from './common.js';

/**
 * Categorias de upload aceitas no v1. Cada categoria tem regras de mime +
 * tamanho aplicadas no servidor.
 */
export const uploadCategorySchema = z.enum(['pdf', 'image']);
export type UploadCategory = z.infer<typeof uploadCategorySchema>;

/**
 * Metadata pública de um upload. `url` é resolvida pelo backend
 * (`${S3_PUBLIC_URL}/${keyStorage}`) — client não precisa montar.
 */
export const uploadSchema = z.object({
  id: idSchema,
  keyStorage: z.string(),
  url: z.string().url(),
  mime: z.string(),
  tamanho: z.number().int().nonnegative(),
  largura: z.number().int().nullable(),
  altura: z.number().int().nullable(),
  alt: z.string().nullable(),
  autorId: idSchema.nullable(),
  criadoEm: isoDateTimeSchema,
});
export type Upload = z.infer<typeof uploadSchema>;

/**
 * Form data esperado pelo POST /uploads:
 *   - file: o arquivo binário
 *   - category: 'pdf' | 'image' (valida regras de mime/tamanho)
 *   - alt: opcional para imagens
 *
 * O Zod aqui valida só os campos textuais — o file vem de
 * `c.req.parseBody()` no Hono e a validação de mime/tamanho fica no handler.
 */
export const uploadFormFieldsSchema = z.object({
  category: uploadCategorySchema,
  alt: z.string().max(300).optional(),
});
export type UploadFormFields = z.infer<typeof uploadFormFieldsSchema>;
